namespace('compass.arctic');

compass.arctic.TextPopupWidget = compass.defineWidget(function TextPopupWidget(options) {
	var me = this;
	var $j = jQuery;
	var d = $j.dom;

	me.render = function (widgetElem) {
		widgetElem.append(
			d.h2(options.title),
			d.div({ className: 'textCopy' }, options.message),
			d.button({
				className: 'secondaryButton',
				role: 'button',
				'aria-role': 'button',
				tabindex: 0
			}, options.buttonText).activate(function () {
				me.trigger(options.triggerName);
			})
		);
	};
}, {
	GUID: 'defaultTextPopupWidgetGUID',
	widgetName: 'TextPopupWidget',
	title: '',
	message: '',
	triggerName: '',
	buttonText: 'OK'
});